module.exports = __webpack_public_path__ + "static/media/03-1-galeria-02-gucci@2x.aa1fffd5.jpg";